import React, { useState, useEffect } from "react";
import DonationHero from "./DonationHero";
import DonationDetails from "./DonationDetails";



export default function Home() {

  return (
    <div>
<DonationHero />
<DonationDetails />
    </div>
  );
}
